import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEY as GET_USER_QUERY_KEY } from '@core/hooks/useGetUser';
import { QUERY_KEY as GET_USERS_QUERY_KEY } from '../../hooks/useUsers';
import { deleteUser } from '../api/deleteUser';

const useDeleteUser = () => {
  const queryClient = useQueryClient()

  const { isLoading, mutateAsync: asyncDeleteUser } = useMutation({
    mutationFn: (userUid: string) => deleteUser(userUid),
    mutationKey: ["UserDelete"],
    onSuccess: () => {
      queryClient.invalidateQueries([GET_USERS_QUERY_KEY])
      queryClient.invalidateQueries([GET_USER_QUERY_KEY])
    }
 });

  return { isLoading, deleteUser: asyncDeleteUser };
};

export default useDeleteUser;
